export enum ProjectType {
  PROJECT = 'PROJECT',
  ONLINE_AUDIT = 'ONLINE_AUDIT'
}

export enum FootprintType {
  SOURCE_WISE = 'SOURCE_WISE',
  DEPARTMENT_WISE = 'DEPARTMENT_WISE',
  SHIPMENT_WISE = 'SHIPMENT_WISE',
  BRAND_WISE_PERCENTAGE = 'BRAND_WISE_PERCENTAGE'
}

export enum ProjectModulePackage {
  GHG_AND_ENERGY = 'GHG_AND_ENERGY',
  CHEMICAL = 'CHEMICAL',
  WASTE = 'WASTE',
  WASTEWATER = 'WASTEWATER',
  WATER = 'WATER'
}

export enum ProjectFactoriesFilterType {
  BRAND_PROJECT_FACTORIES = 'BRAND_PROJECT_FACTORIES',
  CONSULTANT_PROJECT_FACTORIES = 'CONSULTANT_PROJECT_FACTORIES'
}

export enum ProjectVerificationScope {
  SOURCE_WISE = 'SOURCE_WISE',
  DEPARTMENT_WISE = 'DEPARTMENT_WISE',
  BRAND_WISE_PERCENTAGE = 'BRAND_WISE_PERCENTAGE'
}
